import { whyChooseUs } from '../../data/company';
import SectionHeading from '../ui/SectionHeading';
import AnimatedSection from '../ui/AnimatedSection';
import { getIcon } from '../../lib/icons';
import { motion } from 'framer-motion';

export default function WhyChooseUs() {
  return (
    <section className="section-padding bg-charcoal-900">
      <div className="container-custom">
        <AnimatedSection>
          <SectionHeading
            subtitle="Why Choose Us"
            title="Your Trusted Construction Partner"
            description="We combine technical expertise with a client-centered approach to deliver projects that exceed expectations."
            light
          />
        </AnimatedSection>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {whyChooseUs.map((item, index) => {
            const IconComponent = getIcon(item.icon);

            return (
              <AnimatedSection key={index} delay={index * 0.1}>
                <motion.div
                  whileHover={{ y: -4 }}
                  className="p-6 bg-charcoal-800/50 border border-charcoal-700 rounded-2xl hover:bg-charcoal-800 transition-colors"
                >
                  <div className="p-3 bg-primary-600/20 rounded-xl w-fit mb-4">
                    <IconComponent className="w-6 h-6 text-primary-400" />
                  </div>
                  <h3 className="font-semibold text-lg text-white mb-2">
                    {item.title}
                  </h3>
                  <p className="text-charcoal-400 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </motion.div>
              </AnimatedSection>
            );
          })}
        </div>
      </div>
    </section>
  );
}
